export const MODULO = {
  COMERCIAL: 'Comercial',
  COBRANCA: 'Cobrança',
  PLATAFORMA: 'Plataforma',
  ALL: 'ALL',
}

// --- módulo ---
function normalizeModulo(m) {
  if (!m) return ''
  if (m === 'Cobranca') return MODULO.COBRANCA
  return m
}

function getModuloSelecionado() {
  const fromLS = localStorage.getItem('moduloSelecionado')
  if (fromLS) return normalizeModulo(fromLS)

  try {
    const raw = localStorage.getItem('userData')
    if (raw) {
      const parsed = JSON.parse(raw)
      const first = parsed?.modulos?.[0]
      if (first) return normalizeModulo(first)
    }
  } catch { /* ignore */ }

  return ''
}

function includeByModulo(metaModulo, moduloAtual) {
  const m = metaModulo || MODULO.ALL
  if (m === MODULO.ALL && getModuloSelecionado() !== 'Plataforma') return true
  return normalizeModulo(m) === normalizeModulo(moduloAtual)
}

function filterMenuByModulo(list, moduloAtual) {
  return list
    .map(item => {
      if (Array.isArray(item.children) && item.children.length) {
        const filteredChildren = filterMenuByModulo(item.children, moduloAtual)
        if (filteredChildren.length) {
          return { ...item, children: filteredChildren }
        }
        return null
      }
      return includeByModulo(item?.meta?.modulo, moduloAtual) ? item : null
    })
    .filter(Boolean)
}

const RAW_MENU = [
  // 1) Dashboards
  {
    title: 'Dashboard Cobrança',
    route: { path: '/dashboards-cobrancas' },
    icon: 'GridIcon',
    resource: 'dashboardcobranca',
    action: 'read',
    meta: { modulo: MODULO.COBRANCA },
  },
  {
    title: 'Dashboard Comercial',
    route: { path: '/dashboards-comercial' },
    icon: 'BarChart2Icon',
    resource: 'dashboardcomercial',
    action: 'read',
    meta: { modulo: MODULO.COMERCIAL },
  },

  // 2) CRM
  {
    title: 'Painel de Propostas',
    route: { name: 'painel-proposta' },
    icon: 'ClipboardIcon',
    resource: 'painelproposta',
    action: 'read',
    meta: { modulo: MODULO.COMERCIAL },
  },
  {
    title: 'Jornada do Cliente',
    route: { name: 'painel-oportunidades' },
    icon: 'ClipboardIcon',
    resource: 'paineloportunidades',
    action: 'read',
    meta: { modulo: MODULO.COMERCIAL },
  },
  {
    title: 'Portal de Documentos',
    route: { name: 'portaldocumentos-inerno' },
    icon: 'FolderIcon',
    resource: 'portaldocumentosinterno',
    action: 'read',
    meta: { modulo: MODULO.COBRANCA },
  },
  {
    title: 'Empresas',
    route: { path: '/empresas/visualizar' },
    icon: 'BriefcaseIcon',
    resource: 'empresa',
    action: 'read',
    meta: { modulo: MODULO.ALL },
  },
  {
    title: 'Pessoas',
    route: { path: '/pessoas/visualizar' },
    icon: 'UserIcon',
    resource: 'pessoa',
    action: 'read',
    meta: { modulo: MODULO.ALL },
  },
  // 3) Cadastros (Operacionais)
  {
    title: 'Cadastros',
    icon: 'DatabaseIcon',
    children: [
      {
        title: 'Certificados',
        route: { path: '/certificados/visualizar' },
        icon: 'AwardIcon',
        resource: 'certificado',
        action: 'read',
        meta: { modulo: MODULO.COBRANCA },
      },
      {
        title: 'Departamentos',
        route: { path: '/departamentos/visualizar' },
        icon: 'GitBranchIcon',
        resource: 'departamento',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Documentos',
        route: { path: '/documentos/visualizar' },
        icon: 'FileTextIcon',
        resource: 'documento',
        action: 'read',
        meta: { modulo: MODULO.COBRANCA },
      },
      {
        title: 'Equipes',
        route: { path: '/equipes/visualizar' },
        icon: 'UsersIcon',
        resource: 'equipe',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Funções',
        route: { path: '/funcoes/visualizar' },
        icon: 'CheckSquareIcon',
        resource: 'funcao',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Indicações',
        route: { path: '/indicacoes/visualizar' },
        icon: 'Share2Icon',
        resource: 'indicacao',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Licenças',
        route: { path: '/documentos-e-licencas/visualizar' },
        icon: '',
        resource: 'documentolicenca',
        action: 'read',
        meta: { modulo: MODULO.COBRANCA },
      },
      {
        title: 'Pacotes de Serviços',
        route: { path: '/pacote-servicos/visualizar' },
        icon: 'PackageIcon',
        resource: 'pacoteservico',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Serviços',
        route: { path: '/servicos/visualizar' },
        icon: 'ToolIcon',
        resource: 'servico',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Tipos de Atividade',
        route: { path: '/tipo-atividade/visualizar' },
        icon: 'ListIcon',
        resource: 'atividade',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Tipos de Tributação',
        route: { path: '/tipo-tributacao/visualizar' },
        icon: 'PercentIcon',
        resource: 'tributacao',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
    ],
  },

  // 4) Usuários
  {
    title: 'Usuários',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Grupos de Usuários',
        route: { path: '/grupo-usuario/visualizar' },
        icon: 'ShieldIcon',
        resource: 'grupo',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Usuários Externos',
        route: { path: '/usuarios-externos/visualizar' },
        icon: 'UserPlusIcon',
        resource: 'usuexterno',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Usuários Internos',
        route: { path: '/usuarios-internos/visualizar' },
        icon: 'UserCheckIcon',
        resource: 'usuinterno',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
    ],
  },

  // 5) Parametrizações
  {
    title: 'Parametrizações',
    icon: 'SlidersIcon',
    children: [
      {
        title: 'Gerais',
        route: { name: 'parametrizacaogeral' },
        icon: 'SettingsIcon',
        resource: 'parametrizacaogeral',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Checklists',
        route: { path: '/checklists-honorarios/visualizar' },
        icon: 'ClipboardIcon',
        resource: 'parametrizacaochecklist',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Controle de Vencimento',
        route: { name: 'controlevencimento' },
        icon: 'CalendarIcon',
        resource: 'controlevencimento',
        action: 'read',
        meta: { modulo: MODULO.COBRANCA },
      },
      {
        title: 'Modelos de Cobrança',
        route: { path: '/modelos/visualizar' },
        icon: 'FileTextIcon',
        resource: 'modelo',
        action: 'read',
        meta: { modulo: MODULO.COBRANCA },
      },
      {
        title: 'Templates de Proposta',
        route: { path: '/parametrizacao-template-proposta/visualizar' },
        icon: 'MailIcon',
        resource: 'template-proposta',
        action: 'read',
        meta: { modulo: MODULO.COMERCIAL },
      },
      {
        title: 'Templates de Contrato',
        route: { name: 'template' },
        icon: 'Edit3Icon',
        resource: 'template',
        action: 'read',
        meta: { modulo: MODULO.COMERCIAL },
      },
      {
        title: 'Templates de E-mail',
        route: { path: '/template-email/visualizar' },
        icon: 'MailIcon',
        resource: 'templateemail',
        action: 'read',
        meta: { modulo: MODULO.COMERCIAL },
      },
    ],
  },

  // 6) Configurações
  {
    title: 'Configurações',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'API',
        route: { name: 'configuracaoapi' },
        icon: 'CodeIcon',
        resource: 'configuracaoapi',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'E-mails (SMTP)',
        route: { name: 'emailconfig' },
        icon: 'MailIcon',
        resource: 'email',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Notificações',
        route: { name: 'notificacoes' },
        icon: 'BellIcon',
        resource: 'notificacoes',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Proprietários',
        route: { name: 'proprietario' },
        icon: 'UserIcon',
        resource: 'proprietario',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
      {
        title: 'Webhooks',
        route: { name: 'webhooks' },
        icon: 'Share2Icon',
        resource: 'webhooks',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
    ],
  },

  // 7) Segurança / Auditoria
  {
    title: 'Segurança',
    icon: 'ShieldIcon',
    children: [
      {
        title: 'Log Geral',
        route: { name: 'log' },
        icon: 'ActivityIcon',
        resource: 'log',
        action: 'read',
        meta: { modulo: MODULO.ALL },
      },
    ],
  },

  /// Modulo Plataforma
  {
    title: 'Home Plataforma',
    route: { name: 'plataforma' },
    icon: 'BarChartIcon',
    resource: 'plataforma',
    action: 'read',
    meta: { modulo: MODULO.PLATAFORMA },
  },
  {
    title: 'Cadastros',
    icon: 'DatabaseIcon',
    children: [
      {
        title: 'Clientes',
        route: { name: 'implantacoes' },
        icon: 'UsersIcon',
        resource: 'plataformacliente',
        action: 'read',
        meta: { modulo: MODULO.PLATAFORMA },
      },
    ],
  },
  {
    title: 'Configurações',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'E-mails (SMTP)',
        route: { name: 'emailconfigplataform' },
        icon: 'MailIcon',
        resource: 'email',
        action: 'read',
        meta: { modulo: MODULO.PLATAFORMA },
      },
    ],
  },
]

// --- API pública ---
export default async function getNavMenuItems() {
  const modulo = getModuloSelecionado()
  return filterMenuByModulo(RAW_MENU, modulo)
}
